import { Space } from '@tribeplatform/gql-client/types'

import { SpaceTreeItemComponent } from '../components/SpaceTreeItemComponent.js'
import { TreeItems } from '../types.js'

export function spaceTreeIndex(spaceId: string) {
  return `space-${spaceId}`
}

export function createSpaceTreeItem(space: Space): TreeItems {
  return {
    [spaceTreeIndex(space.id)]: {
      index: spaceTreeIndex(space.id),
      isFolder: false,
      data: {
        type: 'space',
        title: space.name,
        space,
        render: () => <SpaceTreeItemComponent space={space} />,
      },
    },
  }
}
